import { ReactNode } from 'react'

import FormattedText from 'shared/ui/FormattedText'

import NumberedListItem from './NumberedListItem'
import {
  SectionCenterHeader,
  SectionWithPadding
} from './styles'

import styles from './AboutUsWhySection.module.scss'

interface AboutUsWhySectionProps {
  header: string
  sectionList: {
    title: string
    content: string | ReactNode
  }[]
}
export default function AboutUsWhySection({
  header,
  sectionList
}: AboutUsWhySectionProps) {
  return (
    <SectionWithPadding
      className={styles.whySection}
      $size='large'
      $desktop
      $tablet
      $mobile
      $condensed
    >
      <SectionCenterHeader>
        <strong>
          <FormattedText text={header} />
        </strong>
      </SectionCenterHeader>
      <ul className={styles.numberedList}>
        {sectionList.map(({ title, content }, index) => (
          <NumberedListItem
            key={title}
            number={`${index + 1}`}
            header={title || ''}
            content={content}
          />
        ))}
      </ul>
    </SectionWithPadding>
  )
}
